var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pb-3"},[_c('organism-qr-access-create-new',{attrs:{"customerByIdc":_vm.customerByIdc},on:{"createSiteAccess":_vm.createSiteAccessToApi,"getCustomerInfoByIdc":_vm.getCustomerInfoByIdc}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }